import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-twitter",
  "use": "spr-twitter-usage",
  "viewBox": "0 0 15.63 12.67",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.63 12.67\" id=\"spr-twitter\"><defs><style>#spr-twitter .cls-1{fill:#545a5e}</style></defs><title>twitter</title><g id=\"spr-twitter_Слой_2\" data-name=\"Слой 2\"><path class=\"cls-1\" d=\"M13.79 2a6.4 6.4 0 0 0 1.84-.5A6.82 6.82 0 0 1 14 3.17v.4a9 9 0 0 1-9.12 9.1A9.1 9.1 0 0 1 0 11.23a6.48 6.48 0 0 0 4.74-1.32 3.2 3.2 0 0 1-3-2.22 3.23 3.23 0 0 0 1.46 0A3.2 3.2 0 0 1 .62 4.5a3.16 3.16 0 0 0 1.46.4 3.19 3.19 0 0 1-1-4.3 9.11 9.11 0 0 0 6.61 3.34A3.21 3.21 0 0 1 13.16 1a6.23 6.23 0 0 0 2-.77A3.21 3.21 0 0 1 13.79 2\" id=\"spr-twitter_Слой_1-2\" data-name=\"Слой 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/twitter.svg
// module id = 284
// module chunks = 0